// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"a1ec630f","285":"db6632b3","505":"f8bef399","652":"b11848b7","903":"fc179467","934":"8079a650"}[chunkId] + ".chunk.js";
};